module.exports = __webpack_public_path__ + "static/img/wxdd.7bf75b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/consultFloatBar/img/wxdd.png
// module id = gvmu
// module chunks = 2